export default "__VITE_ASSET__DJ5IBF8x__";